import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocCenterComponent } from '../doc-center.component';
import { ToastrService } from 'ngx-toastr';
import { DocumentEnum } from '../../../../services/documentsOperation/DocumentEnum';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
// import { S3UploadService } from 'src/app/services/s3Service/s3UploadService.service';
import { HttpEventType } from '@angular/common/http';
import { S3ServiceService } from 'src/app/services/s3Service/s3-service.service';
import { observableToPromise } from 'src/app/services/ObservableToPromise';
import { DocumentsService } from 'src/app/services/documentsOperation/documents-service.service';
import { DocumentsDTO } from 'src/app/dtos/DocumentsDTO';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { isThisISOWeek } from 'date-fns/esm';
import { UserService } from 'src/app/services/user/user.service';
import { FeedbackService } from 'src/app/services/feedback/feedback.service';
import { DocumentUploadService } from 'src/app/services/aadhaarDocumentService/document-upload.service';


@Component({
  selector: 'app-doc-dialog',
  templateUrl: './doc-dialog.component.html',
  styleUrls: ['./doc-dialog.component.scss'],
})
export class DocDialogComponent implements OnInit {
  position = { value: 'above' };
  isDelete: boolean;
  isView: boolean;
  docType: DocumentEnum;
  viewText: string;
  docTypeText: string;
  docSvgLoc: string;
  inputString: string;
  file;
  fileName;
  proofType;
  uploadSelectedDocType;
  aadharNo;
  fileErrors: boolean[] = [];
  DocumentEnum = DocumentEnum;
  documentEnumKeys = Object.keys(DocumentEnum);
  uploadedTypes: string[] = [];
  isAdressProof: boolean = false;
  addressProof = [];
  addressSearch;
  presignedUrl: any;
  type: string;
  aadhaarview: any;
  aadhaarFile: File | null = null;
  aadhaarUrl: string | null = null;

  @ViewChild('previewContent') previewContent!: TemplateRef<any>;

  form: FormGroup;

  documentFieldMap: Record<
    string,
    {
      label: string;
      name: string;
      type: string;
      inputMode: string;
      validators: any[];
    }[]
  >;

  addressProofType = ['Aadhaar', 'Rent Agreement', 'Electricity bill'];

  isLoading: boolean = false;

  documentTypes: string[];
  displayDocumentTypes: string[];
  aadharName;
  selectedDocType = this.fb.control(null);

  document_view_url: SafeResourceUrl;
  document_download_url: string;
  private urlFetchedAt: number;
  private urlValidDurationMs = 15 * 60 * 1000; // 10 minutes
  isImage = false;
  currentUser;


  constructor(
    private toaster: ToastrService,
    private dialogRef: MatDialogRef<DocCenterComponent>,
    private s3Service: S3ServiceService,
    private documentService: DocumentsService,
    public userService: UserService,
    private userDetailService: UserDetailsService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private feedbackService: FeedbackService,
    private modalService: NgbModal,
    private docService: DocumentUploadService,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    this.docType = data?.document?.documentType || '';
    this.type = data?.type || 'ADD';
    this.form = this.fb.group({
      documents: this.fb.array([]),
    });
    this.aadharNo = data?.aadharNo;
    this.aadharName = data?.aadharName;
    this.form.setValidators([this.noDuplicateDocumentsValidator()]);
  }

  noDuplicateDocumentsValidator() {
    return (form: FormGroup) => {
      const types = this.documents.controls.map(
        (ctrl) => ctrl.get('type')?.value
      );
      const hasDuplicates = types.some((t, i) => types.indexOf(t) !== i);
      return hasDuplicates ? { duplicateDocuments: true } : null;
    };
  }

  ngOnInit(): void {
    this.uploadedTypes = this.data?.uploadedTypes || [];
    this.getCurrentUser();
    this.setDocumentTypes();
    this.getSvgImageType();
    this.addressProofFunc();
    this.getaddressProffArray();
    if (this.type === 'EDIT') {
      this.setInitialValues();
    }
  }

  getCurrentUser() {
    this.feedbackService.data$.subscribe((data) => {
      const user_id = data;
      if (user_id) {
        this.userService.getUserByID(user_id).subscribe({
          next: (user) => {
            this.currentUser = user?.body;
          },
          error: (err) => {
            console.error('Error fetching user info', err);
          },
        });
      } else {
        this.currentUser = this.userDetailService.getUserDetails();
      }
    });
  }

  async setInitialValues() {
    let doc_group = this.addDocument(this.docType);
    doc_group?.controls?.documentNumber.setValue(
      this.data?.document?.document_number
    );
    doc_group.controls?.name_on_document?.setValue(
      this.data?.document?.name_on_document
    );
    doc_group.controls?.documentProofType?.setValue(
      this.data?.document?.documentProofType
    );
    doc_group.controls?.issueDate?.setValue(this.data?.document?.issue_at);

    const doc_url = await this.downloadFromS3WithBlob();

    doc_group.controls?.previewUrl?.setValue(doc_url);
    doc_group.controls?.originalFile?.setValue(doc_url);

    this.documents.push(doc_group);
  }

  setDocumentTypes() {
    let geoLocation = '';
    if (this.route.snapshot.paramMap.get('id')) {
      // Getting Geo location for user for different user document upload
    } else {
      // Logged In user geo location defaults to INDIA
      geoLocation = this.currentUser?.geo_location || 'INDIA';
    }

    if (geoLocation === 'INDIA') {
      this.documentFieldMap = this.documentService.FieldMapINDIA;
    } else if (geoLocation === 'USA') {
      this.documentFieldMap = this.documentService.FieldMapUSA;
    }

    this.documentTypes = Object.keys(this.documentFieldMap).map((type) =>
      type.replace(' ', ' ')
    );
  }


  getFormattedType(value: string): string {
    const words = value.toLowerCase().split('_');
    return words
      .map((word) => {
        if (word === 'pan') return 'PAN';
        if (word === 'id') return 'ID';
        if (word === 'license') return 'License';
        if (word === 'address') return 'Proof of Address';
        if (word === 'proof') return '';
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }


  isDisabled(docType: string): boolean {
    const formattedType = docType.toUpperCase().replace(/ /g, '_');
    return this.uploadedTypes.includes(formattedType);
  }
  
  selectedAddressProofType:string;
  shouldFormatAadhaar(index: number, controlName: string,selectedValue?: string): boolean {
  const group = this.documents.at(index);
  const docType = group.get('type')?.value; // main document type
  const addressProofType = group.get('addressProofType')?.value; // if you have a separate control for address proof selection
console.log(group.get('addressProofType'));
console.log(controlName);
console.log(docType);
  console.log(this.selectedAddressProofType);

//   // Apply formatting if it's the documentNumber field and either type is Aadhaar
  return controlName === 'documentNumber' && (docType === 'AADHAAR' || this.selectedAddressProofType === 'Aadhaar');
}

  async ifAadharNo(index: number, selectedValue: string) {
    const documentGroup = this.documents.at(index) as FormGroup;
    const docNumberControl = documentGroup.get('documentNumber');
    const docNameControl = documentGroup.get('name_on_document');

    if (selectedValue === 'Aadhaar') {
      this.selectedAddressProofType=selectedValue;
      if (this.aadharNo && docNumberControl && docNameControl) {

        const aadhaar = await this.docService.getAadhaar();
        docNumberControl.setValue(this.aadharNo);
        docNumberControl.enable();
        docNameControl.setValue(this.aadharName);
        docNameControl.enable();


        documentGroup.get('originalFile')?.setValue(aadhaar.file);
        documentGroup.get('previewUrl')?.setValue(aadhaar.url);
        documentGroup.get('file')?.setValue(aadhaar.file);
      }
    } else {
      docNumberControl.setValue(null);
      docNumberControl.enable();
      docNameControl.setValue(null);
      docNameControl?.enable();
    }
  }

  formatAadhaar(index: number, controlName: string, event: Event) {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/\D/g, ''); // remove non-digits
  if (value.length > 12) value = value.substring(0, 12);

  const formatted = value.replace(/(\d{4})(?=\d)/g, '$1-');
  this.documents.at(index).get(controlName)?.setValue(formatted, { emitEvent: false });
}


  get documents(): FormArray {
    return this.form.get('documents') as FormArray;
  }

  onAddDocClick() {
    const type = this.selectedDocType.value;

    if (!type || this.selectedTypes.includes(type)) {
      return;
    }

    let doc_group = this.addDocument(type);
    this.documents.push(doc_group);
    this.uploadedTypes.push(type.toUpperCase().replace(/ /g, '_'));
    this.selectedDocType.reset();
  }

  addDocument(type: string) {
    const fields = this.documentFieldMap[type.replace(' ', '_')];
    if (!fields) return;
    const group = this.fb.group({
      type: [type.replace(' ', '_'), Validators.required],
      previewUrl: [''],
      originalFile: [null, Validators.required],
      file: [null],
      removed: [false]
    });

    if (this.type === 'EDIT' && this.data?.document?.id) {
      group.addControl(
        'id',
        this.fb.control(this.data?.document?.id, [Validators.required])
      );
      // group.addControl('file', this.fb.control(null));
    }
    // else {
    //   group.addControl('file', this.fb.control('', [Validators.required]));
    // }

    for (const field of fields) {
      if (field.type === 'select') {
        group.addControl(field.name, this.fb.control(null, field.validators));
        continue;
      }
      group.addControl(field.name, this.fb.control('', field.validators));
    }

    return group;
  }

  removeDocument(index: number) {
    const removedType = this.documents.at(index).get('type')?.value;

    if (removedType) {
      const typeIndex = this.uploadedTypes.indexOf(removedType.toUpperCase());
      if (typeIndex > -1) {
        this.uploadedTypes.splice(typeIndex, 1);
      }
    }
    this.documents.removeAt(index);
  }

  removeFile(i: number): void {
    this.documents.at(i).get('originalFile')?.setValue(null);
    this.documents.at(i).get('file')?.setValue(null);
    this.documents.at(i).get('previewUrl')?.setValue(null);
    const inputElement = document.getElementById(`fileInput-${i}`) as HTMLInputElement;
    if (inputElement) inputElement.value = '';
    this.documents.at(i).get('removed')?.setValue(true);
  }

  trackByFn(index: number) {
    return index;
  }

  onFileChange(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      const file = input.files[0];

      const allowedExtensions = ['png', 'jpg', 'jpeg', 'pdf'];
      const extension = file.name.split('.').pop()?.toLowerCase();

      if (!extension || !allowedExtensions.includes(extension)) {
        this.fileErrors[index] = true;
        setTimeout(() => {
          this.fileErrors[index] = false;
        }, 3000);
        this.documents.at(index).get('originalFile')?.setValue(null);
        this.documents.at(index).get('file')?.setValue(null);
        this.documents.at(index).get('previewUrl')?.setValue(null);
        this.documents.at(index).get('removed')?.setValue(true);
        input.value = '';
        return;
      }
      this.fileErrors[index] = false;

      const employee_id = this.currentUser.employeeId;
      const name = `${this.currentUser.firstName} ${this.currentUser.lastName}`;
      const newFileName =
        `${employee_id}_${name}.` + file.name.split('.').pop()?.toLowerCase();
      const renamedFile = new File([file], newFileName, {
        type: file.type,
        lastModified: file.lastModified,
      });
      const fileUrl = URL.createObjectURL(renamedFile);

      this.documents.at(index).get('originalFile')?.setValue(file);
      this.documents.at(index).get('originalFile')?.markAsTouched();
      this.documents.at(index).get('file')?.setValue(renamedFile);
      this.documents.at(index).get('removed')?.setValue(false);
      this.documents.at(index).get('previewUrl')?.setValue(fileUrl);

      const docType = this.documents.at(index).get('type')?.value;
      if (docType === 'AADHAAR') {
        this.docService.setAadhaar(renamedFile, fileUrl);
      }

      if (this.data?.document?.document_name) {
        this.data.document.document_name = null;
      }
    }
    input.value = '';
  }



  get selectedTypes(): string[] {
    return this.documents.controls.map((ctrl) => ctrl.get('type')?.value);

  }

  addressProofFunc() {
    if (this.docType === DocumentEnum.ADDRESS_PROOF) {
      this.isAdressProof = true;
    }
  }
  getaddressProffArray() {
    this.addressProof.push('Electricity Bill');
    this.addressProof.push('Rent Agreement');
    this.addressProof.push('Aadhaar');
  }



  getSvgImageType() {
    if (this.docType == DocumentEnum.AADHAAR) {
      this.docTypeText = 'Aadhaar';
      this.docSvgLoc = '../../../../assets/icons//aadhaar-1-blue-no-text.svg';
    } else if (this.docType == DocumentEnum.PAN) {
      this.docTypeText = 'PAN';
      this.docSvgLoc = '../../../../assets/icons/card_14084369.png';
    } else if (this.docType == DocumentEnum.ADDRESS_PROOF) {
      this.docTypeText = 'Address';
      this.docSvgLoc = '../../../../assets/icons/ba-icon.png';
    } else if (this.docType == DocumentEnum.VOTER_ID) {
      this.docTypeText = 'Voter ID';
      this.docSvgLoc =
        '../../../../assets/icons/ChatGPT Image May 14, 2025, 12_32_32 AM.png';
    } else {
      this.docSvgLoc = '../../../../assets/icons/ba-icon.png';
    }
  }

  closeDialog(isUploaded: boolean = false) {
    this.dialogRef.close({
      isUploaded,
    });
  }

  async handleDocumentUpload(doc: DocumentsDTO, file: any) {
    try {
      if (file) {
        const fileName = file?.name;
        doc.file_extension = fileName.split('.').pop() || '';
        doc.file_size = file?.size;

        // Get presigned URL
        const presignedUrl = await this.getPreSignedURl(
          fileName,
          doc.documentType
        );

        if (!presignedUrl.url) {
          console.error('Presigned URL not found');
          return;
        }

        doc.cloud_storage_path = presignedUrl.objectKey;

        // Upload file to S3 using presigned url
        try {
          await this.s3Service
            .uploadFileToS3(presignedUrl?.url, file)
            .then((data) => { })
            .catch((err) => {
              console.error('Error uploading file:', err);
            });
        } catch (uploadError) { }
      } else if (this.type === 'EDIT') {
        doc.cloud_storage_path = this.data.document.cloud_storage_path;
        doc.file_size = this.data.document.file_size;
        doc.file_extension = this.data.document.file_extension;
        doc.document_name = this.data.document.document_name;
      }

      // Upload document metadata
      await observableToPromise(this.documentService.uploadDocument(doc));
    } catch (e) {
      console.error('Error Fetching Presigned URL', e);
    }
  }

  async getPreSignedURl(filename, docType): Promise<any> {
    const extension = filename.split('.').at(-1);
    const res = await observableToPromise(
      this.s3Service.getPutPresignedUrl(filename, docType, extension)
    );
    return res.body;
  }

  readFile(event: Event) {
    this.file = event[0];
    if (this.file) {
      this.fileName = this.file.name;
    }
  }

  get dialogTitle(): string {
    if (this.type === 'ADD') return 'Add Documents';
    if (this.type === 'EDIT') return 'Edit ' + this.docTypeText;
    return 'Delete ' + this.docTypeText;
  }

  capitalizeWords(str: string): string {
    if (!str) return '';
    return str
      .trim()
      .split(' ')
      .filter(w => w)
      .map(word => word[0].toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  async submit() {
    if (this.form.valid) {
      this.isLoading = true;

      const documents_arr = this.form?.value?.documents || [];
      console.log(documents_arr);

      const uploadPromises = documents_arr.map(async (doc) => {
        const payload: DocumentsDTO = {
          user_id: this.currentUser?.id || '',
          cloud_storage_path: '',
          documentType: doc.type,
          file_extension: '',
          document_name: doc?.file?.name,
          document_number: doc.documentNumber,
          modified_by: this.userDetailService.getUserDetails()?.id,
          issue_at: doc?.issueDate || null,
          name_on_document: doc?.name_on_document
            ? this.capitalizeWords(doc.name_on_document)
            : '',
          documentProofType: doc?.documentProofType || '',
        };

        // this.proofType= payload.documentProofType;
        // this.uploadSelectedDocType=payload.documentType;

        if (this.type === 'EDIT') {
          payload.id = doc.id;
        }
        await this.handleDocumentUpload(payload, doc.file);
        // if(this.checkAadharFunc()){
        //   await this.handleDocumentUpload({...payload,documentType:DocumentEnum.AADHAAR,documentProofType:null}, doc.file);
        // }
      });

      await Promise.all(uploadPromises);
      this.isLoading = false;

      if (this.type === 'EDIT') {
        this.toaster.success('Document has been successfully updated.', 'Success');
      }
      this.closeDialog(true);
    } else {
      this.form.markAllAsTouched();
    }
  }
  checkAadharFunc() {

    if (this.aadharNo) {
      return false
    }
    else if (this.proofType == "Aadhaar" && this.uploadSelectedDocType == "ADDRESS_PROOF" && this.type == 'ADD') {
      return true
    }
    return false
  }

  async downloadFromS3WithBlob(): Promise<String> {
    const now = Date.now();
    if (
      this.document_download_url &&
      this.urlFetchedAt &&
      now - this.urlFetchedAt < this.urlValidDurationMs
    ) {
      return; // Use cached blob URL
    }

    try {
      const response = await observableToPromise(
        this.s3Service.getGetPresignedUrl(this.data.document.cloud_storage_path)
      );

      let url = response.body.url;
      this.urlFetchedAt = now;

      const res = await fetch(url);
      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);
      this.document_view_url = this.sanitizeBlobUrl(objectUrl);
      this.document_download_url = objectUrl;
      return objectUrl;

    } catch (err) {
      console.error('Failed to download from S3:', err);
      this.document_view_url = null;
      this.document_download_url = null;
    }
  }

  sanitizeBlobUrl(blobUrl: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
  }

  get isSaveDisabled(): boolean {
    const hasMissingFile = this.documents.controls.some(doc => !doc.get('originalFile')?.value);

    if (this.type === 'ADD') {
      return this.isLoading || !this.form.valid || this.selectedTypes.length === 0;
    }

    if (this.type === 'EDIT') {
      return hasMissingFile || !this.form.valid || this.isLoading;
    }

    return true; // default disabled if type is something else
  }

  async openPreviewModal(index: number) {
    const doc = this.documents.at(index);
    const file = doc.get('file')?.value;
    if (file) {
      const fileType = file.type;
      this.isImage = fileType.startsWith('image/');
      const fileUrl = doc.get('previewUrl')?.value;
      this.document_view_url = this.sanitizeBlobUrl(fileUrl);
      this.document_download_url = fileUrl;
      this.modalService.open(this.previewContent, { size: 'lg' });
    }
    else {
      if (this.data.document.file_extension == "png" || this.data.document.file_extension == "jpg" || this.data.document.file_extension == "jpeg")
        this.isImage = true;
      this.modalService.open(this.previewContent, { size: 'lg' });
    }
    if (!this.document_view_url) {
      await this.downloadFromS3WithBlob();
      this.modalService.open(this.previewContent, { size: 'lg' });
    }
  }
}
